import { useFormik } from "formik";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  //  useState,
} from "react";
//import innerStyle from "./Login.module.css";
//import styles from "../../../../styles/Username.module.css";
//import extend from "../../../../styles/Profile.module.css";
import { PiUser } from "react-icons/pi";
//import { IoLockClosedOutline } from "react-icons/io5";
import * as api from "helper/helper";
import { resetUsernameValidate } from "../../../../helper/validate";
import toast from "react-hot-toast";
import invalidClass from "../../helperFunctions/helpers";

const UsernameToResetModal = forwardRef(({ item, onOk }, ref) => {
  const modalButtonRef = useRef();

  useImperativeHandle(ref, () => ({
    toggleModal: () => {
      //  formik?.resetForm();
      modalButtonRef.current.click();
    },
  }));

  const formik = useFormik({
    initialValues: {
      username: "",
    },
    enableReinitialize: true,
    validate: resetUsernameValidate,
    validateOnBlur: true,
    validateOnChange: false,
    validateOnMount: false,
    onSubmit: async (values, onSubmitProps) => {
      let response = await api
        .startResetPassword(values.username)
        .catch((error) => {
          toast.error(error.mensaje ?? "ResetPassword Error!");
        });
      if (!response) return;

      if (!response.data.esError) {
        toast.success(response.data.mensaje ?? "ResetPassword Successfully!");
      } else {
        toast.error(response.data.mensaje ?? "ResetPassword Successfully!");
      }
      modalButtonRef.current.click();

      onOk(response);

      formik.resetForm();
    },
  });

  return (
    <>
      {/*<!-- Button trigger modal -->*/}
      <button
        ref={modalButtonRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticUsernameToResetBackdrop"
        hidden
      >
        Launch static backdrop modal
      </button>

      {/*<!-- Modal -->*/}
      <div
        className="modal fade"
        id="staticUsernameToResetBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticUsernameToResetBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id="staticUsernameToResetBackdropLabel"
              >
                Recuperar Contraseña
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form className="row g-3" onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                Proporcione el usuario para recuperar contraseña
                <div className={`col-md-12`}>
                  <label
                    htmlFor="validationDefaultUsername"
                    className="form-label"
                    hidden
                  ></label>
                  <div className="input-group">
                    <span className="input-group-text" id="inputGroupPrepend2">
                      <PiUser />
                    </span>
                    <input
                      type="text"
                      className={`form-control ${invalidClass(
                        formik.errors.username,
                      )}`}
                      id="validationDefaultUsername"
                      aria-describedby="inputGroupPrepend2"
                      placeholder="Username"
                      required
                      {...formik.getFieldProps("username")}
                    />
                    <div className="invalid-feedback">
                      {formik.errors.username}
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <label
                    htmlFor="validationDefaultUsername"
                    className="form-label"
                    hidden
                  ></label>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cerrar
                </button>
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={formik.isSubmitting}
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
});

export default UsernameToResetModal;
